import { c as _c } from "react/compiler-runtime";
import { ReactNode } from "react";
interface IResourceInfoCardProps {
  title: string;
  children: ReactNode;
  className?: string;
}
function ResourceInfoCard(props) {
  const $ = _c(8);
  const {
    title,
    children,
    className: t0
  } = props;
  const className = t0 === undefined ? "" : t0;
  const t1 = `flex flex-col items-start justify-center ${className}`;
  let t2;
  if ($[0] !== title) {
    t2 = <span className="text-[11px] font-semibold uppercase text-[#858585]">{title}</span>;
    $[0] = title;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== children) {
    t3 = <span className="font-semibold leading-[135%] text-[#373B37]">{children}</span>;
    $[2] = children;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t1 || $[5] !== t2 || $[6] !== t3) {
    t4 = <div className={t1}>{t2}{t3}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
}
export default ResourceInfoCard;